var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgMobile = function SvgMobile(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2.001c3.114.01 4.765.108 5.828 1.17C20 4.344 20 6.23 20 10v4c0 3.771 0 5.657-1.172 6.828C17.657 22 15.771 22 12 22c-3.771 0-5.657 0-6.828-1.172C4 19.657 4 17.771 4 14v-2.999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73 4h-.75.75Zm0 .8-.554.506a.75.75 0 0 0 1.108 0L2.73 4.8Zm1.284-.294a.75.75 0 1 0-1.108-1.012l1.108 1.012Zm-1.46-1.012a.75.75 0 0 0-1.108 1.012l1.108-1.012ZM10.27 3.2l.554-.506a.75.75 0 0 0-1.108 0l.554.506Zm-1.284.294a.75.75 0 0 0 1.108 1.012L8.986 3.494Zm1.46 1.012a.75.75 0 0 0 1.108-1.012l-1.108 1.012Zm-5.87 1.8A.75.75 0 0 0 3.461 7.31l1.115-1.003ZM8.54 1.83A.75.75 0 0 0 9.71.892l-1.17.938ZM6.38-.75c-2.494 0-4.4 2.193-4.4 4.75h1.5c0-1.86 1.36-3.25 2.9-3.25v-1.5ZM1.981 4v.8h1.5V4h-1.5Zm1.303 1.306.73-.8-1.108-1.012-.73.8 1.108 1.012Zm0-1.012-.73-.8-1.108 1.012.73.8 1.108-1.012ZM6.62 8.75c2.494 0 4.4-2.193 4.4-4.75h-1.5c0 1.86-1.36 3.25-2.9 3.25v1.5Zm4.4-4.75v-.8h-1.5V4h1.5ZM9.717 2.694l-.73.8 1.108 1.012.73-.8-1.108-1.012Zm0 1.012.73.8 1.108-1.012-.73-.8-1.108 1.012ZM3.46 7.309c.79.879 1.908 1.441 3.158 1.441v-1.5c-.785 0-1.509-.35-2.043-.944L3.461 7.31ZM9.71.892C8.914-.1 7.726-.75 6.381-.75v1.5c.843 0 1.617.404 2.159 1.08L9.71.892Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19H9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgMobile;